export default {
  slug: 'ws-composite-group',
  ADD_WIDGET_TRIGGER_ID: 'add-composite-image-widget',
  CONVERT_TO_GROUP_TRIGGER_ID: 'convert-to-composite-image-widget',
  DEFAULT_MEDIA_SIZE: 150,
  REORDER_COMPOSITE_WIDGET_TRIGGER_ID: 'reorder-composite-widget',
  BRING_TO_FRONT: 'bring-to-front',
  MOVE_FORWARD: 'move-forward',
  SEND_TO_BACK: 'send-to-back',
  MOVE_BACKWARD: 'move-backward',
  COMPOSITE_WIDGET_DUPLICATED_TRIGGER_ID: 'composite-widget-duplicated',
};
